export const getSnackbar = state => state.snackbar.main
export const getShowConfirmation = state => state.snackbar.confirmation

export const getSnackbars = state => state.snackbar.notifications
export const getSnackbarById = id => state =>
  state.snackbar.notifications.find(snackbar => snackbar.key === id) || {}
